
function byteFormatFilter(value) {
	if (typeof value !== 'number' || !isFinite(value)) {
		return '';
	}
	var bytes = Math.abs(value);
	// TODO: support option for KiB, MiB, and GiB byte formats
	if (bytes >= 1000000000000) {
		return +(bytes / 1000 / 1000 / 1000 / 1000).toFixed(2) + ' TB';
	}
	
	if (bytes > 1000000000) {
		return +(bytes / 1000 / 1000 / 1000).toFixed(2) + ' GB';
	}

	if (bytes > 1000000) {
		return +(bytes / 1000 / 1000).toFixed(2) + ' MB';
	}

	if (bytes > 1000) {
		return +(bytes / 1000).toFixed(2) + ' kB';
	}

	return Math.floor(bytes) + ' b';
}

export default byteFormatFilter;




// WEBPACK FOOTER //
// ./src/filters/byte.js